import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { listMonth } from "../actions/monthActions";

export default function Month() {
  const dispatch = useDispatch();
  const { loading, error, months } = useSelector((s) => s.monthList);

  const getMonths = () => {
    dispatch(listMonth());
  };

  useEffect(() => {
    if (!months) getMonths();
  }, [dispatch, months]);

  return loading ? (
    <option value="">Loading...</option>
  ) : months ? (
    months.map((recs, index) => (
      <option key={index + 1} value={recs.Id}>
        {recs.Month}
      </option>
    ))
  ) : (
    <option value="">No Record Exist!</option>
  );
}
